module.exports = __webpack_public_path__ + "img/icon-xmjx.f4564778.png";